import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../components/common/SideBar';

const DashboardLayout: React.FC = () => {
    const { user, logout } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    if (!user) {
        return <div className="p-8 text-center text-gray-600">Loading user data or redirecting...</div>;
    }

    return (
        <div className="flex flex-col lg:flex-row h-screen bg-gray-100 overflow-hidden">
            {/* Sidebar */}
            <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />

            {/* Main content area */}
            <div className="flex-1 flex flex-col h-full">
                {/* Header */}
                <header className="flex items-center justify-between gap-4 p-4 bg-white border-b border-gray-200 shadow-sm">
                    {/* Burger menu (visible on small screens only) */}
                    <button
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                        className="lg:hidden text-gray-700 p-2 rounded-md hover:bg-gray-200 focus:outline-none"
                    >
                        {sidebarOpen ? (
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        ) : (
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        )}
                    </button>

                    <h1 className="text-xl sm:text-2xl font-semibold text-gray-800 flex-1">Dashboard</h1>

                    <div className="flex items-center space-x-4">
                        <span className="text-gray-600 text-sm sm:text-base hidden sm:inline">
                            Welcome, {user.firstName}!
                        </span>
                        <button
                            onClick={logout}
                            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors duration-200 text-sm sm:text-base"
                        >
                            Logout
                        </button>
                    </div>
                </header>

                {/* Scrollable content */}
                <main className="flex-1 overflow-y-auto p-4 sm:p-6">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;

